import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class Issue extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "htmlUrl", Model.attribute('htmlUrl'));
    _defineProperty(this, "title", Model.attribute('title'));
    _defineProperty(this, "body", Model.attribute('body'));
    _defineProperty(this, "state", Model.attribute('state'));
    _defineProperty(this, "stateReason", Model.attribute('stateReason'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "updatedAt", Model.attribute('updatedAt', Model.transformDate));
    _defineProperty(this, "comments", Model.attribute('comments'));
    _defineProperty(this, "pullRequest", Model.attribute('pullRequest'));
    _defineProperty(this, "user", Model.attribute('user'));
    _defineProperty(this, "labels", Model.attribute('labels'));
    _defineProperty(this, "milestone", Model.hasOne('milestone'));
  }
}
flarum.reg.add('sycho-github-milestone', 'forum/models/Issue', Issue);